
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.166 1.362c.004.05.004.063.012.113a.836.836 0 00.232.448l5 5c.037.035.046.044.086.075a.834.834 0 001.007 0c.04-.03.049-.04.086-.075l5-5c.035-.037.044-.046.075-.086a.837.837 0 00.088-.861.84.84 0 00-1.004-.437.833.833 0 00-.252.13c-.04.031-.049.04-.085.075L6 5.155 1.589.745l-.042-.04c-.04-.031-.048-.04-.09-.068a.835.835 0 00-1.279.555c-.008.05-.008.063-.012.113v.057z","fill":"#44474A"}})])
          )
        }
      }
    